import Promise from 'bluebird';
import _ from 'lodash';

import api from '../api';
import { converter } from '../core/converter';
import infoBoard from '../core/infoboard';
import worldMap from '../core/map';
import translate from '../core/tools/translate';
import templates from '../core/templates';
import environment from '../environment';
import { customScrollbar, isLayerEnabled } from '../shared';
import { setExportActionCss } from '../../utils';
import { selectMarker } from '../shared/map';
import { CONFIG } from '../../config';

const LayerControls = (name) => require('../controls').get(name);
const LayerInfo = (name) => require('../info').get(name);

const currentLayer = () => LayerControls('NewGreenfield').getLayer();
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const name = 'NewGreenfield';

const _getContainer = () =>
    infoBoard.createContainer({
        id: 'newgreenfield',
        name: translate('Common.NewGreenfield')
    });

const _getImage = latlng =>
    new Promise((resolve) => {
        const images = {
            original: '#',
            thumbnail: `https://maps.googleapis.com/maps/api/streetview?size=${worldMap.getThumbImageSize()}&location=${latlng.lat},${latlng.lng}&sensor=false&key=${CONFIG.GOOGLE_MAPS_API_KEY}`
        };
        return resolve(images);
    });

const _getInfo = (feature, resultType) =>
    new Promise((resolve) =>
        api.newGreenfield.getGreenfield(feature.properties.Id, resultType).then(response => resolve(response))
    );

const _getContext = function () {
    return _.values(environment.get('CONFIG.FILTERS.POINTS_TYPES'))[0];
};

class NewGreenfieldInfo {
    static getInstance() {
        if (!NewGreenfieldInfo._instance) {
            NewGreenfieldInfo._instance = new NewGreenfieldInfo();
        }

        return NewGreenfieldInfo._instance;
    }

    init() {
    }

    _getFeatureLayer(feature) {
        return currentLayer().getLayer(feature.properties.Id);
    }

    _updateVoronoi(feature, layer) {
        if (worldMap.hasLayer(layer)) {
            return LayerControls('Voronoi').add([feature]);
        } else {
            return LayerControls('Voronoi').remove([feature.properties.Id]);
        }
    }

    create(features) {
        if (infoBoard.locked) {
            return;
        }

        const container = _getContainer();

        if (infoBoard.dataUnavailable({
            features,
            container,
            isEnabled: isLayerEnabled(name)
        })) {
            return;
        }

        const context = _getContext();

        const template = $(templates('infoboard-content', {
            id: 'points-collapse',
            actions: isAuthorized('points-summary-export')
        }));
        const content = template.find('.panel-group');

        features.forEach(feature => {
            let item;
            let layer = this._getFeatureLayer(feature);

            const options = {
                feature,
                name: name.toLocaleLowerCase(),
                originalName: name,
                container,
                controls: {
                    info: true,
                    summary: false,
                    compare: false,
                    hideStore: true
                },
            };

            item = infoBoard.createItem(options);
            if (!item) {
                return;
            }

            if (item.btn.info) {
                item.btn.info.on('click', e => {
                    e.preventDefault();
                    const queue = [];
                    const coordinates = {
                        lat: feature.geometry.coordinates[1],
                        lng: feature.geometry.coordinates[0]
                    };
                    queue.push(_getInfo(feature, context));
                    queue.push(_getImage(coordinates));
                    Promise.all(queue).then(response => {
                        const data = response[0];
                        data.image = response[1];
                        data.name = feature.properties['PointName'].toCapitalCase();
                        data.id = feature.properties['IdPoint'];
                        data.headerClass = 'point-info-subheader';
                        LayerInfo('Resume').show(data, {
                            resultType: 'NewGreenfield',
                            visible: true,
                            title: translate('Common.PointInfo'),
                            latlng: coordinates,
                            callbackBack: () => {
                                infoBoard.showInfo('NewGreenfield', feature.properties.Id);
                                worldMap.getCurrent().fireEvent('click');
                            },
                        });
                    });

                    selectMarker(layer, feature, 'NewGreenfield', 'points');
                });
            }

            if (item.btn.hideStore) {
                if (currentLayer().isHidden(feature.properties.Id)) {
                    $(item.btn.hideStore).parent().find('i').toggleClass('fa-eye-slash');
                    $(item.btn.hideStore).parent().find('a').text(translate('Action.Show'));
                    item.title.toggleClass('disabled');
                    this._updateVoronoi(feature, layer);
                } else {
                    $(item.btn.hideStore).parent().find('i').toggleClass('fa-eye');
                    $(item.btn.hideStore).parent().find('a').text(translate('Action.Hide'));
                }

                item.btn.hideStore.on('click', () => {
                    layer = this._getFeatureLayer(feature) || layer;
                    LayerControls('NewGreenfield').toggleVisibility(feature.properties.Id, layer);

                    this._updateVoronoi(feature, layer);
                });
            }

            $(content).append(item.layout);
        });

        // give the DOM a break
        $(container).detach().append(template).appendTo('#infoboard-content');

        // add context panel
        const actions = infoBoard.createActions({
            export: {
                value: isAuthorized('points-summary-export'),
                label: translate('Action.ExportPoints')
            }
        }, 'NewGreenfield');

        if (actions.export) {
            actions.layout.appendTo(container);
        }

        if (actions.export) {
            setExportActionCss();
            $(actions.export).on('click', e => {
                e.stopPropagation();
                converter.csv({
                    name: 'pis_da_area',
                    type: context,
                    data: features
                });
            });
        }

        customScrollbar(content);
    }
}

export default NewGreenfieldInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/NewGreenfieldInfo.js